import { useEffect } from "react";

/**
 * Captures the `?ref=` URL parameter on any page load and persists it
 * in localStorage for 30 days. The RegisterPage reads this back and
 * sends it in the registration body so the backend can attribute the
 * new user to the affiliate.
 *
 * Replaces the legacy hp_ref cookie flow which was unreliable
 * cross-origin.
 */
const STORAGE_KEY = "hp_affiliate_ref";
const STORAGE_TS_KEY = "hp_affiliate_ref_at";
const TTL_DAYS = 30;

export function useAffiliateRef() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref && /^[A-Z0-9_-]{3,50}$/i.test(ref)) {
      try {
        localStorage.setItem(STORAGE_KEY, ref.toUpperCase());
        localStorage.setItem(STORAGE_TS_KEY, String(Date.now()));
      } catch (_) {
        // localStorage may be disabled (private mode + iOS) — fail silently
      }
    }
  }, []);
}

export function getAffiliateRef() {
  try {
    const ref = localStorage.getItem(STORAGE_KEY);
    const ts = parseInt(localStorage.getItem(STORAGE_TS_KEY) || "0", 10);
    if (!ref || !ts) return null;
    if (Date.now() - ts > TTL_DAYS * 24 * 3600 * 1000) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_TS_KEY);
      return null;
    }
    return ref;
  } catch (_) {
    return null;
  }
}

export function clearAffiliateRef() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_TS_KEY);
  } catch (_) {
    // ignore
  }
}
